import { inherits as _inherits, createSuper as _createSuper, classCallCheck as _classCallCheck, defineProperty as _defineProperty, assertThisInitialized as _assertThisInitialized, asyncToGenerator as _asyncToGenerator, createClass as _createClass } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import _pt from '../../../node_modules/prop-types/index.js';
import React from 'react';
import { connect } from 'react-redux';
import { abortableApi } from '../../../modules/abort/actions.js';

var TriggerBase = /*#__PURE__*/function (_React$Component) {
  _inherits(TriggerBase, _React$Component);

  var _super = _createSuper(TriggerBase);

  function TriggerBase(props) {
    var _this;

    _classCallCheck(this, TriggerBase);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "defaultState", function (props) {
      return {
        submitting: false,
        slowSubmitting: false,
        success: false,
        error: undefined,
        data: undefined
      };
    });

    _defineProperty(_assertThisInitialized(_this), "_isMounted", false);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      _this._isMounted = true;
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      _this._isMounted = false;
      if (_this.props.abortSubmitOnUnmount) _this.onAbortSubmit();
    });

    _defineProperty(_assertThisInitialized(_this), "onSubmit", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _this$props, submitAction, submitParams, submitSlowDelay, onSubmit, onSubmitted, dispatch, data, submitResponse, submittingAction, slowTimeout, _yield$dispatch, success, error, response;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props = _this.props, submitAction = _this$props.submitAction, submitParams = _this$props.submitParams, submitSlowDelay = _this$props.submitSlowDelay, onSubmit = _this$props.onSubmit, onSubmitted = _this$props.onSubmitted, dispatch = _this$props.dispatch;

              if (onSubmit) {
                data = onSubmit(submitParams);

                _this.setState({
                  success: true,
                  data: data
                });
              }

              submitResponse = undefined;

              if (!submitAction) {
                _context.next = 23;
                break;
              }

              submittingAction = abortableApi(submitAction(submitParams));

              _this.setState({
                submittingAbort: submittingAction.abort,
                submitting: true,
                error: undefined
              });

              slowTimeout = setTimeout(function () {
                if (!_this._isMounted) return;

                _this.setState({
                  slowSubmitting: true
                });
              }, submitSlowDelay);
              _context.next = 9;
              return dispatch(submittingAction);

            case 9:
              _yield$dispatch = _context.sent;
              success = _yield$dispatch.success;
              error = _yield$dispatch.error;
              response = _yield$dispatch.response;
              clearTimeout(slowTimeout); // prevent state changes after unmounting

              if (_this._isMounted) {
                _context.next = 16;
                break;
              }

              return _context.abrupt("return");

            case 16:
              if (success) {
                _context.next = 21;
                break;
              }

              _this.setState({
                submitting: false,
                slowSubmitting: false,
                success: false,
                error: error
              });

              return _context.abrupt("return");

            case 21:
              _this.setState({
                submitting: false,
                slowSubmitting: false,
                success: true,
                data: response
              });

              submitResponse = response;

            case 23:
              if (onSubmitted) {
                onSubmitted(submitResponse, submitParams, {});
              }

            case 24:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _defineProperty(_assertThisInitialized(_this), "onReset", function () {
      var defaultState = _this.defaultState(_this.props);

      _this.setState(defaultState);
    });

    _defineProperty(_assertThisInitialized(_this), "onAbortSubmit", function () {
      var submittingAbort = _this.state.submittingAbort;
      if (submittingAbort) submittingAbort.abort();
    });

    _this.state = _this.defaultState(props);
    return _this;
  }

  _createClass(TriggerBase, [{
    key: "render",
    value: function render() {
      var _this$state = this.state,
          submitting = _this$state.submitting,
          slowSubmitting = _this$state.slowSubmitting,
          success = _this$state.success,
          error = _this$state.error,
          data = _this$state.data;
      var fireTrigger = this.onSubmit;
      var state = {
        submitting: submitting,
        slowSubmitting: slowSubmitting,
        success: success,
        error: error,
        data: data
      };
      var events = {
        onReset: this.onReset,
        onAbortSubmit: this.onAbortSubmit
      };
      return this.props.render(fireTrigger, state, events);
    }
  }]);

  return TriggerBase;
}(React.Component);

_defineProperty(TriggerBase, "propTypes", {
  submitAction: _pt.func,
  submitParams: _pt.any,
  submitSlowDelay: _pt.number.isRequired,
  onSubmit: _pt.func,
  onSubmitted: _pt.func,
  render: _pt.func.isRequired,
  abortSubmitOnUnmount: _pt.bool.isRequired,
  dispatch: _pt.any.isRequired
});

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    dispatch: dispatch
  };
};

var connectBase = function connectBase() {
  return connect(null, mapDispatchToProps)(TriggerBase);
};

var TriggerBaseComponent = connectBase();

var TriggerBase$1 = function TriggerBase$1(props) {
  return /*#__PURE__*/React.createElement(TriggerBaseComponent, props);
};

export { TriggerBase$1 as default };
